import {Injectable} from '@angular/core';
import {ModalController} from '@ionic/angular';
import {SelecaoFiltroPage} from '../components/selecao-filtro/selecao-filtro.page';

export class OptionsModal {
    lista?: string;
    showPesquisa: boolean;
    titulo: string;
    nomeAtributoDescricao: string;
    nomeAtributoCodigo: string;
}

@Injectable()
export class ModalProvider {

    constructor(
        private modalController: ModalController
    ) {
    }

    async show(options: OptionsModal, cssClass = 'custom-modal-select') {
        const modal = await this.modalController.create({
            component: SelecaoFiltroPage,
            keyboardClose: true,
            animated: true,
            cssClass,
            componentProps: options
        });

        await modal.present();
        const {data} = await modal.onWillDismiss();
        return data;
    }


}
